// Replace characters that are not a digit, minus or dot with an empty string
export var convertCurrencyToNumber = amount => parseFloat(amount.replace(/[^-0-9.]/g, ''));
var currencyDetails = {
  USD: {
    icon: 'united-states',
    sign: '$'
  }
};
export var getCurrencyDetails = currency => currencyDetails[currency];
export var defaultCurrency = 'USD';
export var defaultIntegerLimit = Number.MAX_SAFE_INTEGER;
//# sourceMappingURL=currency-utils.js.map